import React from 'react';
import { MetaTags } from '@/types/meta-tags';
import Head from 'next/head';

type SeoProps = {
  meta: MetaTags;
};

const Seo = ({ meta }: SeoProps) => (
  <Head>
    {meta &&
      Object.keys(meta).map((tag: string) => (
        <meta
          name={tag.includes('og:') ? undefined : tag}
          property={tag.includes('og:') ? tag : undefined}
          content={meta[tag as keyof MetaTags]}
          key={tag}
        />
      ))}
  </Head>
);

export default Seo;
